import axios from "axios";

const apiBase = "/api/legacy/saved-card/";

export async function getCards() {
    return await axios.get(apiBase + "get-cards");
}

export async function createCard() {
    return await axios.get(apiBase + "create-card");
}

export async function linkCard(
    cardId: number,
    destination: string | null | undefined = null
) {
    return await axios.get(apiBase + "link-card", {
        params: {
            cardId,
            destination,
        },
    });
}

export async function linkCardFrame(cardId: number) {
    return await axios.get(apiBase + "link-card-frame", {
        params: {
            cardId,
        },
    });
}

export async function checkCardAccepted(cardId: number) {
    return await axios.get(apiBase + "check-card-accepted", {
        params: {
            cardId,
        },
    });
}

export async function checkCardIsRequiredForUser() {
    return await axios.get<{ required: boolean }>(
        apiBase + "check-card-required-for-user"
    );
}
